import React from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import { DocContentImage, DocSidebarImage } from '../component/DocMedia';
import SettingsMenuOverview from './SettingsMenuOverview';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function TicketNotificationSettings() {
  const { t } = useTranslation();
  const image001 = useDocImage('ticket-notifications-settings-img', 'image001.png', 'settings');
  const image002 = useDocImage('ticket-notifications-settings-img', 'image002.png', 'settings');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.ticketNotificationSettings.title')}</h1>
            <p className="header-para">{t('documentation.ticketNotificationSettings.intro')}</p>

            <div className="card dashboard-card mb-4">
              <div className="card-header px-3">{t('documentation.ticketNotificationSettings.accessing.title')}</div>
              <div className="card-body">
                <SettingsMenuOverview />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.ticketNotificationSettings.accessing.steps.step1') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.ticketNotificationSettings.accessing.steps.step2') }} />
                </ul>
                <DocSidebarImage src={image001} alt={t('documentation.ticketNotificationSettings.accessing.imageAlt')} />
                <ul className="mb-0">
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.ticketNotificationSettings.accessing.steps.step3') }} />
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header px-3">{t('documentation.ticketNotificationSettings.recipients.title')}</div>
              <div className="card-body">
                <DocContentImage src={image002} alt={t('documentation.ticketNotificationSettings.recipients.imageAlt')} />
                <ul>
                  <li>{t('documentation.ticketNotificationSettings.recipients.items.search')}</li>
                  <li>{t('documentation.ticketNotificationSettings.recipients.items.add')}</li>
                  <li>{t('documentation.ticketNotificationSettings.recipients.items.remove')}</li>
                  <li>{t('documentation.ticketNotificationSettings.recipients.items.save')}</li>
                </ul>
              </div>
            </div>

            <p className="alert alert-info mb-0">{t('documentation.ticketNotificationSettings.permissionsNote')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
